import { AbdooLogo, b2cPolicies, msalInstance } from '@abdoo/common';
import { Button, Grid } from '@mui/material';
import React, { useCallback } from 'react';

import abdooLogo from '../logos/Abdoo logo + safe area_256px-height.png';
export const Login = () => {
  const loginRedirect = useCallback(() => {
    msalInstance.loginRedirect(b2cPolicies.authorities.SignupSignin);
  }, []);

  const registerRedirect = useCallback(() => {
    msalInstance.loginRedirect(b2cPolicies.authorities.Signup);
  }, []);

  return (
    <>
      <Grid container justifyContent="center">
        <AbdooLogo src={abdooLogo} />
      </Grid>

      <Grid container justifyContent="center">
        <Grid
          container
          justifyContent="center"
          sx={{ paddingLeft: '1em', paddingRight: '1em' }}
        >
          <Grid
            item
            sx={{
              width: '400px',
              margin: '10px 0',
            }}
          >
            <Button style={{ width: '100%' }} variant="contained" onClick={loginRedirect}>
              Login
            </Button>
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="center"
          sx={{ paddingLeft: '1em', paddingRight: '1em' }}
        >
          <Grid
            item
            sx={{
              width: '400px',
              margin: '10px 0',
            }}
          >
            <Button
              style={{ width: '100%' }}
              variant="outlined"
              onClick={registerRedirect}
            >
              Register
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
